"use strict";

import axios from "axios";

import {
  AddUpdateDelete_CHARACTER_FOR_PROJECT,
  APPEND_CHARACTER,
  GET_CHARACTERS_FOR_PROJECT,
} from "../../ApiEndpoints.js";

export const CHARACTER_NAME_MAX_LENGTH = 100;

/**
 * Saves a new display name for one character of a project.
 *
 * @returns {Promise<boolean>} false when the character is no longer on the
 * project; network errors are thrown.
 */
export const renameCharacter = async ({ projectId, speaker, name }) => {
  // updatecharacters overwrites the whole array, so start from the full
  // list (including soft-deleted characters) to avoid dropping any.
  const { data } = await axios.post(GET_CHARACTERS_FOR_PROJECT, {
    projectId,
    includeDeleted: true,
  });

  const allCharacters = Array.isArray(data?.characters) ? data.characters : [];

  if (!allCharacters.some((item) => item.speaker === speaker)) {
    return false;
  }

  const updatedCharacters = allCharacters.map((item) =>
    item.speaker === speaker ? { ...item, displayName: name } : item
  );

  await axios.post(AddUpdateDelete_CHARACTER_FOR_PROJECT, {
    projectId,
    characters: updatedCharacters,
  });

  return true;
};

/**
 * Adds a new character with no voices to a project. The backend gives it a
 * `speaker` key that is unique within the project.
 *
 * @returns {Promise<object>} the saved character.
 */
export const createCharacter = async ({ projectId, name }) => {
  const { data } = await axios.post(APPEND_CHARACTER, {
    projectId,
    character: { displayName: name, voices: [] },
  });

  return data.character;
};

/**
 * The message to show when a character write fails. A 409 means the list
 * would give two characters the same key; the backend says which.
 */
export const characterWriteErrorMessage = (error, fallback) =>
  error?.response?.status === 409 && error.response.data?.error
    ? error.response.data.error
    : fallback;
